import { createApp } from 'vue'
import App from './App.vue'
import Vue from "vue";

//element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
//引入vue-router
import router from "./router";
import store from "./store"
//全局属性，方法，组件入口
import plugins from "./assets/js/plugins"
import "@/assets/font/font.css";
import '@/assets/css/main.css'
import '@/assets/icon/iconfont.css'
import NProgress from 'nprogress'  // 进度条；进度指示器
import 'nprogress/nprogress.css' // 进度条；进度指示器 样式
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'//element-plus
// import * as util from '../public/js/util'
import * as tool from "../public/js/util"
import {  ImagePreview, Swipe,SwipeItem , Button ,DropdownMenu, DropdownItem,Field ,Popup,Picker,Overlay,Cell, CellGroup,Checkbox, CheckboxGroup,Icon,List ,Calendar,ActionSheet } from "vant";

// 引入rem适配
import './assets/js/rem.js';
NProgress.configure({     
  easing: 'ease',  // 动画方式    
  speed: 500,  // 递增进度条的速度    
  showSpinner: false, // 是否显示加载ico    
  trickleSpeed: 200, // 自动递增间隔    
  minimum: 0.3 // 初始化时的最小百分比
});
// Vue.prototype.util = util;

//监听路由跳转，进入页面执行插件动画。
router.beforeEach((to, from , next) => {
  // 每次切换页面时，调用进度条
  NProgress.start();

  // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
  next();
});
//跳转结束了
router.afterEach(() => {  
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})
const app = createApp(App);
app.config.globalProperties.tool=tool
app.use(router)
app.use(DropdownMenu);
app.use(Calendar);
app.use(Icon);
app.use(Swipe)
app.use(SwipeItem);
app.use(DropdownItem);
app.use(Popup);
app.use(Field);
app.use(Picker);
app.use(Overlay);
app.use(Cell);
app.use(CellGroup);
app.use(Checkbox);
app.use(CheckboxGroup );
app.use(List);
app.use(ImagePreview );


app.use(ActionSheet);
app.use(Button);


app.use(ElementPlus,{'locale':zhCn})
app.use(plugins);
app.use(store)
window.vm=app.mount('#app')